document.addEventListener('DOMContentLoaded', function () {
    // Accordian javascript
    let isAnimating = false;

    // open first accordion items on load. can't hard code this since its in a cms, der.
    // document.querySelector()
    $('.single-accord:first-of-type .b').addClass('current').show();
    $('.single-accord:first-of-type .accordion').addClass('change-color');
    $('.single-accord:first-of-type span').addClass('rotate-icon');

    $('.single-accord .h').on('click', function (e) {
        // limiting scope of interaction to just one carousel when more than one carousels are on the page.
        const $curAccord = $(this).parent().parent();
        if (!isAnimating) {
            isAnimating = true;
            if ($(this).next().hasClass('current')) {
                $curAccord.find('.single-accord .h .plus').removeClass('rotate-icon');
                $curAccord.find('.single-accord .accordion').removeClass('change-color');
                $(this).next().removeClass('current').slideUp(function () {
                    isAnimating = false;
                });
            } else {
                $curAccord.find('.single-accord .b').slideUp().removeClass('current');
                $curAccord.find('.single-accord .h .plus').removeClass('rotate-icon');
                $curAccord.find('.single-accord .accordion').removeClass('change-color');
                $(this).next().addClass('current').slideToggle(function () {
                    isAnimating = false;
                });
                $(this).find('span').addClass('rotate-icon');
                $(this).find('.accordion').addClass('change-color');
            }
        }
    });
});